export const EPIC_WEB_ANALYTICS_EVENT = 'EPIC_WEB_ANALYTICS_EVENT';
export const EPIC_EVENT_TRACKING = 'EPICEVENTTRACKING';

/**
 * @see https://github.ol.epicgames.net/online-web/tracking-site/blob/master/node/app/scripts/client/classes/TrackingPixel.js
 */
export enum TrackingEventTypes {
    PageView = 'PageView',
    Interaction = 'Interaction'
}

export enum InteractionTypes {
    CLICK = 'CLICK',
    LAUNCH_FROM_LIBRARY = 'WEB_LAUNCH_FROM_LIBRARY',
    LAUNCH_FROM_PRODUCT_DETAILS_PAGE = 'WEB_LAUNCH_FROM_PRODUCT_DETAILS_PAGE',
    LAUNCH_FROM_RECENTLY_PLAYED = 'WEB_LAUNCH_FROM_RECENTLY_PLAYED',
    SCROLL = 'SCROLL'
}

export enum FunnelIds {
    HOME = 'home',
    LIBRARY = 'library',
    PRODUCT = 'product'
}

// @depreciated
export const trackingEventTypes = TrackingEventTypes;
export const interactionTypes = InteractionTypes;
export const funnelIds = FunnelIds;
